import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box 
      sx={{ 
        mt: 'auto',
        py: 3, 
        width: '100%',
        backgroundColor: 'grey.100', 
        borderTop: 1, 
        borderColor: 'grey.300' 
      }}
    >
      <Container maxWidth="lg">
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ textAlign: 'center' }}
        >
          © {new Date().getFullYear()} Nexfah motoring. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;